import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';

export default function Loader({ isLoading = false, children = null }) {
  if (!isLoading) {
    return children;
  }

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Card>
        <UiKit.Card.Body>
          <UiKit.Flex align="center" justify="space-between">
            <UiKit.Flex gap={16} align="center">
              <Skeleton height={16} width={140} />
              <Skeleton height={24} width={56} />
            </UiKit.Flex>
            <Skeleton height={24} width={56} />
          </UiKit.Flex>
        </UiKit.Card.Body>
      </UiKit.Card>
    </SkeletonTheme>
  );
}
